import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { CalendarScheduleClockIcon } from '@moia-dev/pace-icons'
import { ShiftsAreaDataTestIds } from './ShiftsAreaDataTestIds'
import { ShiftsAreaRoutes } from './ShiftsAreaRoutes'

export const ShiftsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ShiftsAreaRoutes.route}
      Icon={CalendarScheduleClockIcon}
      dataTestId={ShiftsAreaDataTestIds.Navigation}
    />
  )
}
